import { FormlyFieldConfig } from '@ngx-formly/core';
import { DetailsFormOptions } from './details-form-options.interface';
import { toFormlyOptions, namePattern, isRapidProgram, isBCTRequiredStage } from './details-form-helpers';

/**
 * SECTION 2.3: CLIENT PERSONAL QUESTIONS
 */
export function getClientPersonalFields(options: DetailsFormOptions): FormlyFieldConfig[] {
  return [
    // Personal Information
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          className: 'col-sm-6 col-lg-4',
          key: 'First_Name',
          type: 'input',
          props: {
            label: 'First Name',
            required: true,
            maxLength: 20,
          },
          validators: {
            namePattern: {
              expression: (c: any) => !c.value || namePattern.test(c.value),
              message:
                'Cannot contain digits or start/end with special characters',
            },
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Middle_Name',
          type: 'input',
          props: {
            label: 'Middle Name',
            maxLength: 20,
          },
          validators: {
            namePattern: {
              expression: (c: any) => !c.value || namePattern.test(c.value),
              message:
                'Cannot contain digits or start/end with special characters',
            },
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Last_Name',
          type: 'input',
          props: {
            label: 'Last Name',
            required: true,
            maxLength: 40,
          },
          validators: {
            namePattern: {
              expression: (c: any) => !c.value || namePattern.test(c.value),
              message:
                'Cannot contain digits or start/end with special characters',
            },
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Gender',
          type: 'select',
          props: {
            label: 'Gender',
            options: [
              { value: 'Male', label: 'Male' },
              { value: 'Female', label: 'Female' },
            ],
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Do_you_have_another_name',
          type: 'select',
          props: {
            label: 'Do you have another name?',
            options: [
              { value: 'Yes', label: 'Yes' },
              { value: 'No', label: 'No' },
            ],
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Alternative_Name',
          type: 'input',
          props: {
            label: 'Alternative Name',
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Number_of_Dependents',
          type: 'input',
          props: {
            label: 'Number of dependents',
            type: 'text',
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Date_of_Birth',
          type: 'datepicker',
          props: {
            label: 'Date of Birth',
          },
          expressions: {
            'props.required': (field: FormlyFieldConfig) =>
              isRapidProgram(field),
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Marital_Status',
          type: 'select',
          props: {
            label: 'Marital Status',
            options: toFormlyOptions(options.maritalStatuses$),
          },
        },
      ]
    },
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          className: 'col-sm-6',
          key: 'best_contact_time_range',
          type: 'time-range-picker',
          props: {
            label: 'Best contact time',
            limitStartTime: 8,
            limitEndTime: 20,
          },
          expressions: {
            'props.required': (field: FormlyFieldConfig) =>
              isBCTRequiredStage(field)
          },
        },
        {
          className: 'col-sm-6',
          key: 'best_voe_contact_time_range',
          type: 'time-range-picker',
          props: {
            label: 'Best time to contact for VOE',
            limitStartTime: 8,
            limitEndTime: 20,
          },
        },
      ]
    },
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Email1',
          type: 'input',
          props: {
            label: 'Email',
            type: 'email',
          },
          expressions: {
            'props.required': (field: FormlyFieldConfig) =>
              isRapidProgram(field),
          },
          validators: {
            email: {
              expression: (c: any) =>
                !c.value || /^\S+@\S+\.\S+$/.test(c.value),
              message: 'Invalid email address',
            },
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Mobile',
          type: 'phone',
          props: {
            label: 'Best contact number',
          },
          expressions: {
            'props.required': (field: FormlyFieldConfig) =>
              isRapidProgram(field),
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Phone',
          type: 'phone',
          props: {
            label: 'Other contact number',
          },
        },       
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Does_you_own_a_car',
          type: 'select',
          props: {
            label: 'Do you currently own a car?',
            options: [
              { value: 'Yes', label: 'Yes' },
              { value: 'No', label: 'No' },
            ],
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'What_is_the_value_of_the_car',
          type: 'currency',
          props: {
            label: 'What is the value of the car?',
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Last_Contact_Date',
          type: 'datepicker',
          props: {
            label: 'Last contact date',
          },
        }, 
        {
          className: 'col-sm-6 col-lg-4',
          key: 'S_I_N',
          type: 'sin',
          props: {
            label: 'SIN',
          },
          validators: {
            validation: ['sin'],
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'No_SIN_Reason',
          type: 'select',
          props: {
            label: 'No SIN Reason',
            options: toFormlyOptions(options.noSinReasons$),
          },
        },
        // {
        //   className: 'col-sm-6 col-lg-4',
        //   key: 'Co_Appl_Required',
        //   type: 'select',
        //   props: {
        //     label: 'Co-Applicant Required?',
        //     options: [
        //       { value: 'Yes', label: 'Yes' },
        //       { value: 'No', label: 'No' },
        //     ],
        //   },
        // },
      ],
    },
    // Address Section Header
    {
      type: 'section-header',
      props: {
        label: 'Address',
      },
    },

    // Address Section
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Address1',
          type: 'google-address',
          props: {
            label: 'Address line 1',
            onAddressSelect: (result: any) =>
              options.onAddressSelect(result, 'MAIN'),
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Address_Line_2',
          type: 'input',
          props: {
            label: 'Address Line 2 (Unit number)',
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'City',
          type: 'input',
          props: {
            label: 'City',
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Province',
          type: 'input',
          props: {
            label: 'Province',
            readonly: true,
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Postal_Code',
          type: 'postal-code',
          props: {
            label: 'Postal Code',
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Length_of_Residence',
          type: 'input',
          props: {
            label: 'Length of Residence',
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Monthly_Payments',
          type: 'currency',
          props: {
            label: 'Monthly Payments',
          },
        },
      ],
    },

    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          className: 'col-sm-6 mt-3',
          wrappers: ['panel'],
          props: {
            label: 'Co-Applicant',
          },
          expressions: {
            className: (field: FormlyFieldConfig) =>
              field.model?.Co_Appl_Required === 'Yes' ? 'col-sm-6 mt-3' : 'col-sm-6 col-lg-4 mt-3',
          },
          fieldGroupClassName: 'row',
          fieldGroup: [
            {
              className: 'col-6',
              key: 'Co_Appl_Required',
              type: 'select',
              props: {
                label: 'Co-Applicant Required?',
                options: [
                  { value: 'Yes', label: 'Yes' },
                  { value: 'No', label: 'No' },
                ],
              },
              expressions: {
                className: (field: FormlyFieldConfig) =>
                  field.model?.Co_Appl_Required === 'Yes' ? 'col-6' : 'col-12',
              },
            },
            {
              className: 'col-6',
              key: 'Co_Applicant_LPP',
              type: 'yes-no-toggle',
              props: {
                label: 'No LPP Co-Applicant Included?',
              },
              expressions: {
                hide: (field: FormlyFieldConfig) =>
                  field.model?.Co_Appl_Required !== 'Yes',
              },
            },
          ],
        },
      ]
    },
		
  ]
}